/**
 * La pagina iniziale del gestionale: dove si arriva dopo l'accesso e dove
 * rimanda una schermata che il ruolo non apre.
 *
 * DIPENDE DALLO STILE DELL'UTENZA (interruttore dello stile, Alex 14/10/2026).
 * Lo stile nuovo «Console» non si vede in clinica finche' non e' completo:
 *   - stile di prima (spento, il predefinito): /dashboard, come nel commit
 *     638a8209; /oggi rimanda li';
 *   - stile nuovo (acceso per l'utenza): /oggi («Oggi», proposta 26, fase 2;
 *     Alex 2/10/2026, domanda 7); /dashboard rimanda li', per i segnalibri
 *     della clinica e le prove che la aprivano.
 * Lo decide il server (backend/services/stileNuovo.js) e arriva con l'utente,
 * `stile_nuovo: true|false`: il browser non decide da se'. Un utente senza
 * il campo (una sessione aperta prima dell'interruttore) e' allo stile di
 * prima.
 *
 * Un file a parte, e non una costante in schermate.js, perche' la leggono
 * anche Login e CambiaPassword, che schermate.js importa: da li' sarebbe un
 * giro di import.
 */
export const PAGINA_INIZIALE_CLASSICA = '/dashboard';
export const PAGINA_INIZIALE_NUOVA = '/oggi';

/** Lo stile nuovo e' acceso per questo utente? Solo un `true` del server. */
export const stileNuovo = (utente) => utente?.stile_nuovo === true;

/** La pagina iniziale di questo utente (anche senza utente: lo stile di prima). */
export const paginaIniziale = (utente) =>
    (stileNuovo(utente) ? PAGINA_INIZIALE_NUOVA : PAGINA_INIZIALE_CLASSICA);

export default paginaIniziale;
